import Jsona from 'jsona';

import SnakeModelPropertiesMapper from './snake_model_properties_mapper';
import SnakeJsonPropertiesMapper from './snake_json_properties_mapper';

export default new Jsona({
  modelPropertiesMapper: new SnakeModelPropertiesMapper(),
  jsonPropertiesMapper: new SnakeJsonPropertiesMapper(),
});



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/data_formatter/index.js